import { Injectable } from '@angular/core';
import { Infracao, InfracaoMotivo } from '@tivic-team/manager-ts/dist/mob';
import { InfracaoMotivoController } from 'app/controllers/mob/infracao-motivo.controller';
import { LoaderService } from '../loader.service';
import { InfracaoMotivoSearch } from './infracao-motivo-search';

@Injectable()
export class InfracaoMotivoService {

    constructor (
        private _infracaoMotivoController: InfracaoMotivoController,
        private _loaderService: LoaderService
    ) {}

    async getAll():Promise<Infracao[]> {
        this._loaderService.show();
        return this._infracaoMotivoController.getAll().finally(() => {
            this._loaderService.hide();
        });
    }

    async findMotivos(infracaoMotivoSearch?: InfracaoMotivoSearch): Promise<InfracaoMotivo[]> {
        return await this._infracaoMotivoController.findMotivos(infracaoMotivoSearch && infracaoMotivoSearch.getFilters() || null);
    }
}